import React, {Component} from 'react';

export default class Redirect extends Component {

    constructor() {
        super();
        let url_str = window.location.href;
        let url = new URL(url_str);
        let param = url.searchParams.get("action");
        if (param === null) {
            window.opener.postMessage("success", '*');
            window.close();
        } else {
            window.opener.postMessage(param, '*');
            window.close();
        }
    }

}
